





































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import * as Reveal from '@/assets/scripts/RevealOnScrollModule'
import * as VideoModal from '@/assets/scripts/VideoModalModule'

@Component
export default class Home extends Vue {
    data() {
        return {
            PageTitle: "Video modal"
        }
    }
    mounted() {
        new VideoModal.videoModalModule()
        new Reveal.revealOnScrollModule()
    }
}
